import React, { useContext, useEffect, useRef, useState } from "react";
import { MainContext } from "../App";
import Api from "./api/api";
import { jwtDecode } from "jwt-decode";
import logo from "../images/logo.png";

function Login() {
	const { setLoading, setToast, setUser } = useContext(MainContext);
	const emailRef = useRef();
	const passwordRef = useRef();
	const [shops, setShops] = useState([]);
	const [shopId, setShopId] = useState("");

	useEffect(() => {
		loadShops();
	}, []);

	async function loadShops() {
		const response = await Api.post("/shops/list/", {
			orderby: "position",
			fields: ["id", "name", "license_expires_at"],
			depth: 0,
			src: [{ name: "active", value: 1, compare: "equal" }],
		});
		const rows = response.rows || [];
		setShops(rows);
		const saved = rows.find((s) => s.id == localStorage.getItem("waiter-shop-id"));
		if (saved && !saved.license_expired) setShopId(String(saved.id));
		else if (rows.length === 1 && !rows[0].license_expired) setShopId(String(rows[0].id));
	}

	// stessa regola di App.loadShops: gli admin vedono tutti i negozi, gli altri solo quelli associati
	function isShopAllowed(user, shop_id) {
		if (parseInt(user?.role?.admin) === 1) return true;
		const allowed = (Array.isArray(user?.shops) ? user.shops : []).map((s) => parseInt(s.id));
		if (allowed.length > 0) return allowed.includes(parseInt(shop_id));
		if (user?.shop_id) return parseInt(user.shop_id) === parseInt(shop_id);
		return false;
	}

	const handleSubmit = async (e) => {
		e.preventDefault();

		const request = {
			email: emailRef.current.value,
			password: passwordRef.current.value,
		};
		setLoading(true);
		const login = await Api.login(request);
		setLoading(false);
		if (login.success == 0) setToast(login.error);
		else {
			const decoded = jwtDecode(login.token);
			localStorage.setItem("waiter-user", login.token);
			const response = await Api.getProtected("/users/get/" + decoded.user_id + "/");
			if (response.success == 0) alert(response.error);
			else if (!isShopAllowed(response.data, shopId)) {
				localStorage.removeItem("waiter-user");
				setToast("Operatore non abilitato al negozio selezionato");
			} else {
				localStorage.setItem("waiter-shop-id", shopId);
				setUser(response.data);
			}
		}
	};

	return (
		<div className="login">
			<form className="content" onSubmit={handleSubmit}>
				<div className="login-logo"><img src={logo} /></div>
				<h2>APP Cameriere</h2>
				<div className="form-group">
					<select value={shopId} onChange={(e) => setShopId(e.target.value)} required>
						<option value="">Seleziona il negozio</option>
						{shops.map((s) => (
							<option key={s.id} value={s.id} disabled={!!s.license_expired}>
								{s.name}
								{s.license_expired ? " (licenza scaduta)" : ""}
							</option>
						))}
					</select>
				</div>
				<div className="form-group">
					<input type="email" ref={emailRef} autoComplete="username" required placeholder="Email" />
				</div>
				<div className="form-group">
					<input
						type="password"
						ref={passwordRef}
						autoComplete="current-password"
						required
						placeholder="Password"
					/>
				</div>
				<button type="submit" className="btn btn-primary btn-block">
					Accedi
				</button>
			</form>
		</div>
	);
}

export default Login;
